import { css } from "@emotion/react";
import { theme } from "@/constants/theme";

export const previewSection = css({
  width: "100%",
  maxWidth: 1440,
  margin: "80px auto",
  [theme.breakpoints.down("md")]: {
    ".slick-list": {
      padding: "0 8px !important",
    },
    marginTop: "40px",
  },
});
